<button
    size="lg"
    class="cdp-grid-col-menu-btn cdp-simple-ico-btn"
    hc-icon-button
    [hcPop]="columns"
    title="Configure columns in data grid"
>
    <hc-icon fontIcon="icon-table-cog"></hc-icon>
</button>

<hc-pop #columns>
    <div hcMenu [formGroup]="colSelectionForm" cdkDropList (cdkDropListDropped)="columnDropped($event, false)">
        <div class="cdp-col-menu-header"><span class="icon-table-cog"></span>Configure Columns</div>
        <div class="cdp-col-menu-subheader">
            <button hc-button buttonStyle="link" size="sm" (click)="selectAll()">Select all</button>
            <button hc-button buttonStyle="link" size="sm" (click)="clearAll()">Clear all</button>
        </div>
        <ng-container *ngFor="let column of availableDataCols">
            <div
                hcMenuItem
                class="cdp-grid-col-menu-item"
                *ngIf="column.isHidable"
                cdkDrag
                title="Drag to rearrange columns, click to toggle"
            >
                <span class="icon-grip"></span>
                <hc-checkbox [formControlName]="column.key" [tight]="true" (change)="onColChange()">{{
                    column.title
                }}</hc-checkbox>
            </div>
        </ng-container>
        <div class="cdp-col-menu-footer">
            <button hc-button buttonStyle="primary" size="sm" (click)="columns.close()">Done</button>
        </div>
    </div>
</hc-pop>
